import React, {Component} from 'react';

import "react-table/react-table.css";
import '../css/style.css';
import 'react-datepicker/dist/react-datepicker.css';

import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import couterpart from 'counterpart';
import { FaFilter } from 'react-icons/fa';
import { TiRefresh } from 'react-icons/ti';
import { ICON_COLOR } from '../icon';

import MenuComponent2 from './MenuComponent2';
import AuthenticationService from '../services/AuthenticationService';
import MaterialService from '../services/MaterialService';
import MaterialStockService from '../services/MaterialStockService';
import { MATERIAL_STOCK_STATUS_DELIVERED } from '../constants';
import {MATERIAL_STATUS_NEW, MATERIAL_STATUS_CHANGING, MATERIAL_STATUS_CHANGED, MATERIAL_STATUS_IN_USED, MATERIAL_STATUS_EMPTY, MATERIAL_STATUS_DELETED} from '../constants';

class Material extends Component{
    constructor() {
        super();
        this.state = {
            materials:[],
            show: false,
            defaultQuantity: 400,
            id: 0,
            remainQuantity: 0,
            quantity: 0,
            batchNoOld: '',
            batchNo: '',
            inputBatchNo: '',
            replacedItems: []
        };
    };

    componentDidMount () {
        this.loadMaterials();  
    }

    loadMaterials(){
        MaterialService.fetchMaterials().then(data => {
            this.setState({ 
                materials:  data
            }, () => {
                this.sleep(500).then(() => {
                    this.scanBatchNo.focus();
                })
            });
        });
    }

    getWarningInfo(item){
        if (item.status === 2){
            return "lightgreen";
        }
        if (item.quantity > 50){
            return 'green';
        }
        if (item.quantity <= 0){
            return 'red';
        }
        if (item.quantity <= 50){
            return 'yellow';
        }                
    }

    handleInputBatchNoChange(e){
        var value = e.target.value;
        this.setState(prevState => ({
            inputBatchNo: value                   
        }));
    }

    processOrder(){
        let batchNo = this.state.inputBatchNo;
        this.setState({ 
            batchNo: batchNo
        }, () => {
            if (this.state.batchNo !== undefined && this.state.batchNo.trim().length > 0){
                MaterialStockService.fetchMaterialStockByBatchNo(this.state.batchNo).then(materialStockItem => {
                    if (materialStockItem === undefined || materialStockItem === null || materialStockItem.id === undefined){
                         alert("Không tìm thấy nguyên liệu");
                         this.setState({inputBatchNo: ''}, () => {
                             this.scanBatchNo.focus();
                         });
                         
                    } else {
                        // console.log("materialStockItem", materialStockItem);
                        if (materialStockItem.status !== MATERIAL_STOCK_STATUS_DELIVERED){
                            alert("Tình trạng của nguyên liệu không hợp lệ");
                            this.setState({inputBatchNo: ''}, () => {
                                this.scanBatchNo.focus();
                            });
                        } else {
                            MaterialService.fetchMaterialCode(materialStockItem.code).then(materialItem => {
                                //console.log("materialItem", materialItem);
                                this.handleEdit(materialItem, materialStockItem);
                            }); 
                        }
                    }
                })
            }
        });
    }

    handleKeyDown(e){
        if (e.key === 'Enter') {
            this.processOrder()
        }
    }

    handleResetReplacedItem(){
        this.setState({ replacedItems: [] });
    }  

    handleReplacedItem(){

    }   

    renderMaterialList() {
        if (this.state.materials === undefined || this.state.materials === null || !(this.state.materials instanceof Array)){
            return (<></>);
        }

        if (AuthenticationService.isXi()){
            return (
                <>
                    <div className="row">
                        <div className="col-4">
                            <input type="text" value={this.state.inputBatchNo} name="scanBatchNo" id="scanBatchNo" autoFocus ref={ input => this.scanBatchNo = input } style={{width:"100%", marginTop: "5px"}}
                                placeholder={couterpart.translate('material_stock_batch_no')}
                                onChange={this.handleInputBatchNoChange.bind(this)} onKeyDown={this.handleKeyDown.bind(this)}/>
                        </div>
                        <div className="col-1">
                            <button className="myButton"  onClick={ this.processOrder.bind(this) }>
                                <FaFilter color={ICON_COLOR}/>
                                &nbsp;{couterpart.translate('button_filter')}</button>
                        </div>
                        <div className="col-1">
                            <button className="myButton"  onClick={ this.loadMaterials.bind(this) }>
                                <TiRefresh color={ICON_COLOR}/>
                                &nbsp;{couterpart.translate('button_reload')}</button>
                        </div>
                    </div>
                    {/* <div className="row" style={{ marginBottom: "10px"}}>
                        <div className="col-12">
                            { this.renderUsedItems() }
                        </div>
                    </div>
                    <div className="row" style={{marginBottom: "10px", textAlign: "center"}}>
                        <div className="col-12">
                            <Button className="btn-primary-s" onClick={this.handleResetReplacedItem.bind(this)} style={{ marginRight: "5px"}}>{ couterpart.translate('button_reset') }</Button>
                            <Button variant="primary" onClick={ this.handleReplacedItem.bind(this) }>{ couterpart.translate('button_replaced') }</Button>
                        </div>
                    </div> */}
                    <div className="row">
                        <div className="col-1 border-top border-left border-right border-light-gray table_header">
                            { 'STT' }
                        </div>
                        <div className="col-2 border-top border-left border-right border-light-gray table_header">
                            { 'Code' }
                        </div>                    
                        <div className="col-2 border-top border-left border-right border-light-gray table_header">
                            { 'Số lượng' }
                        </div>
                        <div className="col-4 border-top border-left border-right border-light-gray table_header">
                            { 'Batch No' }
                        </div>
                        <div className="col-2 border-top border-left border-right border-light-gray table_header">
                            { 'Tình trạng' }
                        </div>
                        <div className="col-1 border-top border-left border-right border-light-gray table_header">
                            { 'CẢNH BÁO' }
                        </div>
                    </div>
                    {this.state.materials.map((item, index) => {
                        if (index % 2 === 0){
                            return (
                            <div className="row" key={item.id} style={{ backgroundColor: "lightblue"}}>
                                <div className="col-1 border-top border-left border-right border-bottom border-light-gray">
                                    <label>{ index + 1 }</label>
                                </div>
                                <div className="col-2 border-top border-left border-right border-bottom border-light-gray">
                                    <label className="label_link">{ item.code }</label>
                                </div>                            
                                <div className="col-2 border-top border-left border-right border-bottom border-light-gray">
                                    <label>{ item.quantity }</label>
                                </div>
                                <div className="col-4 border-top border-left border-right border-bottom border-light-gray">
                                    <label>{ item.batchNo }</label>
                                </div>
                                <div className="col-2 border-top border-left border-right border-bottom border-light-gray">
                                    <label>{ this.getStatusDescription(item.status) }</label>
                                </div>
                                <div className="col-1 border-top border-left border-right border-bottom border-light-gray" style={{ backgroundColor: this.getWarningInfo(item) }}>
                                    &nbsp;
                                </div>                
                            </div>
                            )
                        } else {
                            return (
                            <div className="row" key={item.id} style={{ backgroundColor: "white"}}>
                                <div className="col-1 border-top border-left border-right border-bottom border-light-gray">
                                    <label>{ index + 1 }</label>
                                </div>
                                <div className="col-2 border-top border-left border-right border-bottom border-light-gray">
                                    <label className="label_link">{ item.code }</label>
                                </div>
                                <div className="col-2 border-top border-left border-right border-bottom border-light-gray" style={{ alignContent: "right"}}>
                                    <label>{ item.quantity }</label>
                                </div>
                                <div className="col-4 border-top border-left border-right border-bottom border-light-gray">
                                    <label>{ item.batchNo }</label>
                                </div>
                                <div className="col-2 border-top border-left border-right border-bottom border-light-gray">
                                    <label>{ this.getStatusDescription(item.status) }</label>
                                </div>
                                <div className="col-1 border-top border-left border-right border-bottom border-light-gray" style={{ backgroundColor: this.getWarningInfo(item) }}>
                                    &nbsp;
                                </div>                
                            </div>
                            )            
                        }
                    })
                }
            </>);
        }
        return (<></>);
    }

    getStatusDescription(status){
        if (status === MATERIAL_STATUS_NEW) {
            return 'Mới';
        }

        if (status === MATERIAL_STATUS_CHANGING) {
            return 'Đang thay cốc';
        }

        if (status === MATERIAL_STATUS_CHANGED) {
            return 'Đang thay cốc';
        }

        if (status === MATERIAL_STATUS_IN_USED) {
            return 'Đang sử dụng';
        }                
        
        if (status === MATERIAL_STATUS_EMPTY) {
            return 'Sử dụng hết';
        }

        if (status === MATERIAL_STATUS_DELETED) {
            return 'Hết sủ dụng';
        }
        return status + '';
    }

    handleQuantityChange(e){
        var value = e.target.value;
        this.setState({                 
            quantity: value                   
        });
    }

    handleBatchNoChange(e){
        var value = e.target.value;
        this.setState({                 
            batchNo: value                   
        });
    }

    handleEdit(item, itemStock){
        this.setState({ show: true, remainQuantity:  item.quantity, quantity: itemStock.quantity, id: item.id, batchNoOld: item.batchNo, batchNo: itemStock.batchNo, currentStatus: item.status });
    }

    handleClose(){
        this.setState({ show: false });
    }

    sleep(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }

    saveInfo(){
        MaterialService.updateQuantity({id: this.state.id, quantity: this.state.quantity, batchNo: this.state.batchNo }).then(() => {
            this.loadMaterials();
            this.setState({ show: false, inputBatchNo: '' }, () =>{
                this.sleep(500).then(() => {
                    this.scanBatchNo.focus();
                })
            });
        });
    }

    renderUsedItems(){
        if (this.state.replacedItems === undefined || this.state.replacedItems === null || this.state.replacedItems.length < 1){
            return (
            <table border = "1px" width="100%">
                <thead>
                    <tr>
                        <th>Batch No</th>
                        <th>Số lượng</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>&nbsp;</td>
                        <td>&nbsp;</td>
                    </tr>
                </tbody>
            </table>
            );
        }
        return(
            <table border = "1px" width="100%">
                <thead>
                    <tr>
                        <th>Batch No</th>
                        <th>Số lượng</th>
                    </tr>
                </thead>
                <tbody>
                    { this.state.replacedItems.map(x => 
                        <tr key={x.batchNo}>
                            <td>{ x.batchNo }</td>
                            <td>{ x.dungTich }</td>
                        </tr>
                        )
                    }
                </tbody>
            </table>
        );
    }       

    render(){
        if(!AuthenticationService.isAdmin() && !AuthenticationService.isSupervisor() && !AuthenticationService.isXi()){
            return (<div>Unauthorized access.</div>);
        }
        
        return (
            <div>
                <MenuComponent2 />
                <div className="row" style={{ margin: "20px"}}>
                    <div className="col-10">
                        { this.renderMaterialList() }
                    </div>
                </div>
                <Modal show={this.state.show} onHide={this.handleClose.bind(this)} backdrop="static"  dialogClassName="modal-60w">
                  <Modal.Header closeButton>
                      <Modal.Title>Nhập nguyên liệu</Modal.Title>
                  </Modal.Header>
                  <Modal.Body> 
                        <div className="row">
                            <div className="col-6">
                                <span className="field_margin">{ couterpart.translate('material_no_remain') } : </span>
                            </div>                        
                            <div className="col-6">
                                <label>{this.state.remainQuantity} </label>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-6">
                                <span className="field_margin">{ couterpart.translate('material_current_status') } : </span>
                            </div>                        
                            <div className="col-6">
                                <label>{ this.getStatusDescription(this.state.currentStatus) }</label>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-6">
                                <span className="field_margin">{ couterpart.translate('material_no_batch_no_old') } : </span>
                            </div>                        
                            <div className="col-6">
                                <label>{this.state.batchNoOld} </label>
                            </div>
                        </div>                                                                     
                        <div className="row" style={{ marginTop: "5px" }}>
                            <div className="col-6">
                                <span className="field_margin">{ couterpart.translate('material_no_batch') } : </span>
                            </div>                        
                            <div className="col-6">
                                <label>{this.state.batchNo} </label>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-6">
                                <span className="field_margin">{ couterpart.translate('material_quantity') } : </span>
                            </div>                        
                            <div className="col-6">
                                <label>{this.state.quantity} </label>
                            </div>
                        </div>                     
                  </Modal.Body>
                  <Modal.Footer>
                    <Button variant="primary" onClick={this.handleClose.bind(this)}>Cancel</Button>
                    <Button variant="primary" onClick={this.saveInfo.bind(this)}>Thay cốc</Button>  
                  </Modal.Footer>
              </Modal>
            </div>
        );
    }
}

export default Material;
